import classNames from 'classnames';
import React, { useState } from 'react';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import PopOver from '../components/deprecated/PopOver';
import PopOverContainer from '../components/deprecated/PopOverContainer';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated/gql';
import informationIcon from '../icons/non-prefilled/16x16/information.svg';
import ClickOutsideHandler from '../utils/ClickOutsideHandler';
import { LayoutSize } from '../utils/responsive/Sizes';
import useIsLayoutSize from '../utils/responsive/useIsLayoutSize';
import styles from './ControlBar.module.scss';
import ControlBarInsights from './ControlBarInsights';
import PostLastEdited from './topbar/PostLastEdited';

const POST_FRAGMENT = gql(`
  fragment ControlBar_post on PublicPostFields {
    id
    ... on Post {
      ...PostLastEdited_post
      ...ControlBarInsights_post
    }
  }
`);

const modifiers = [
  {
    name: 'offset',
    options: {
      offset: (x: { placement: string }) =>
        x.placement.endsWith('end') ? [18, 12] : [-18, 12],
    },
  },
];

interface ControlBarProps {
  post: DocumentType<typeof POST_FRAGMENT>;
}

const ControlBar = ({ post }: ControlBarProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  if (isMobile && isOpen) {
    setIsOpen(false);
  }

  return (
    <div className={styles.container}>
      {post.__typename === 'Post' && (
        <ClickOutsideHandler onClickOutside={() => setIsOpen(false)}>
          <Button
            className={classNames(styles.edited, {
              [styles.active]: isOpen,
              [styles.disabled]: isMobile,
            })}
            disabled={isMobile}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            {!isMobile && (
              <PopOver
                arrow={<PopOverContainer.Arrow />}
                placement="bottom-end"
                open={isOpen}
                onOpenChange={() => {}}
                modifiers={modifiers}
                popOver={
                  <ControlBarInsights
                    post={post}
                    close={() => setIsOpen(false)}
                  />
                }
                trigger="click"
                disablePersist
                preventCloseOnContentClick
                popOverPortal={document.body}
              >
                <SVGIcon>{informationIcon}</SVGIcon>
              </PopOver>
            )}
            <PostLastEdited post={post} showInitial />
          </Button>
        </ClickOutsideHandler>
      )}
    </div>
  );
};

export default ControlBar;
